import { generateJSON } from '@tiptap/html'
import { activeTipTapExtensions } from './activeTipTapExtensions.mjs'

export function getTextFromHtml(
  html,
  extensions = activeTipTapExtensions.get(),
  insertLists = true,
  insertNewLines = true,
) {
  if (!html) return ''
  return getTextFromNode(
    generateJSON(html, extensions),
    insertLists,
    insertNewLines,
  ).trim()
}

export function getTextFromNode(
  node,
  insertLists = true,
  insertNewLines = true,
) {
  if (!node) return ''
  return getText(node, insertLists, insertNewLines).trim()
}
function getText(jsonNode, insertLists = true, insertNewLines = true) {
  let result = ''

  // console.log('Getting text from node', jsonNode)
  if (jsonNode.type === 'text') {
    result += jsonNode.text
  } else if (jsonNode.content?.length > 0) {
    result += jsonNode.content
      .map((child, i) => {
        let result = ''
        if (insertLists) {
          let isBullet =
            jsonNode.type === 'bulletList' ||
            (jsonNode.type === 'customListItem' &&
              jsonNode.attrs['list-style-type']?.startsWith('unordered'))

          let isOrdered =
            jsonNode.type === 'orderedList' ||
            (jsonNode.type === 'customListItem' &&
              jsonNode.attrs['list-style-type']?.startsWith('ordered'))
          result +=
            (isBullet ? '\t— ' : '') +
            (isOrdered ? `\t${jsonNode.attrs['item-number'] + 1}. ` : '')
        }

        return result + getText(child)
      })
      .join('')
  }
  if (jsonNode.type === 'paragraph' && insertNewLines) {
    result += '\n'
  }
  return result
}
